// API Errors
export enum Errors {
  Validation = 400,
  Unauthorized = 401,
  AccessDenied = 403,
  NotFound = 404,
  State = 409,
  InternalServerError = 500,
}
